import { render, staticRenderFns } from "./WatchlistInnerTabNavigation.vue?vue&type=template&id=537dbc40"
import script from "./WatchlistInnerTabNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchlistInnerTabNavigation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WatchlistInnerTabNavigation.vue?vue&type=style&index=0&id=537dbc40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports